__turbopack_context__.v({
  "currencyLabel": "productPrice-module-scss-module__UL4doa__currencyLabel",
  "currencySymbol": "productPrice-module-scss-module__UL4doa__currencySymbol",
  "keyclubLabel": "productPrice-module-scss-module__UL4doa__keyclubLabel",
  "keyclubPrice": "productPrice-module-scss-module__UL4doa__keyclubPrice",
  "originalPrice": "productPrice-module-scss-module__UL4doa__originalPrice",
  "originalPriceContainer": "productPrice-module-scss-module__UL4doa__originalPriceContainer",
  "percentageSaved": "productPrice-module-scss-module__UL4doa__percentageSaved",
  "price": "productPrice-module-scss-module__UL4doa__price",
  "priceFor": "productPrice-module-scss-module__UL4doa__priceFor",
  "productCardPrice": "productPrice-module-scss-module__UL4doa__productCardPrice",
  "productPrice": "productPrice-module-scss-module__UL4doa__productPrice",
  "productPriceContainer": "productPrice-module-scss-module__UL4doa__productPriceContainer",
  "promoPrice": "productPrice-module-scss-module__UL4doa__promoPrice",
  "saleLabel": "productPrice-module-scss-module__UL4doa__saleLabel",
});
